import type { DevPreview } from "@/modules/dev/types/DevPreview";
import type { DevScenario } from "@/modules/dev/types/DevScenario";

import { getDevPreview } from "./previews";

/**
 * Demo presets shown at the top of `/dev`. Open applies the preview, its
 * search params and the viewport; Copy link copies the same URL.
 */
export const DEV_SCENARIOS: readonly DevScenario[] = [
  {
    id: "session-booked-card",
    label: "Session Booked card with the Google Meet link",
    talkingPoint: "Confirmation panel for a coach booking, phone width.",
    previewId: "booking-end-states",
    search: { view: "coach" },
    viewport: "phone",
    ticket: "MEM-1314",
    cycle: 22,
  },
  {
    id: "survey-retry",
    label: "Survey retry after a network failure",
    talkingPoint:
      "Loads offline, retries, recovers when the connection is restored.",
    previewId: "survey-loading",
    search: { scenario: "offline" },
    viewport: "phone",
    ticket: "MEM-1159",
    cycle: 22,
  },
  {
    id: "coach-matching-public",
    label: "Public Coach Matching booking page",
    talkingPoint:
      "Real route with name, email and source prefilled. Needs bifrost on staging.",
    previewId: "coach-matching",
    viewport: "fit",
    ticket: "MEM-1364",
    cycle: 22,
  },
];

/** Cycles that have scenarios, newest first. */
export const getScenarioCycles = () =>
  [...new Set(DEV_SCENARIOS.map((scenario) => scenario.cycle))].sort(
    (a, b) => b - a,
  );

/** The registry preview a scenario opens. */
export const getScenarioPreview = (scenario: DevScenario): DevPreview => {
  const preview = getDevPreview(scenario.previewId);
  if (!preview) throw new Error(`Unknown dev preview "${scenario.previewId}"`);

  return preview;
};
